import compact from 'lodash/compact';

import selectGamePath from './game-path';
import selectGameKeys from './select-game-keys';

const selectGameSummary = (psychometrics, { summary, detailedResults }, attributesPath) => {
  if (!psychometrics) return null;

  let moreInfo = null;

  if (attributesPath) {
    moreInfo = {
      key: 'detailedResults',
      value: '',
      descriptor: '',
      link: {
        children: detailedResults,
        href: attributesPath,
      },
    };
  }

  return compact([
    {
      key: 'games',
      value: `${psychometrics.timesPlayed}/4`,
      descriptor: summary.gamesPlayed,
    },
    moreInfo,
  ]);
};

const selectScoreCardPsychometrics = (
  { psychometrics },
  { psychometrics: { gameTitle, gameDescription, playNow }, ...restPhrases },
  remainingChallenges,
  attributesPath,
) => ({
  heroKey: 'personality',
  gameTitle,
  gameDescription,
  imageUrl: 'https://images.ctfassets.net/gtqjh9j40j4m/2kVY9ifEa1jU2gd3TLPeDp/77eafb2307841cc2fb2501a666e511cf/personality-icon-background.png',
  summary: selectGameSummary(psychometrics, restPhrases, attributesPath),
  nextGamePath: selectGamePath(remainingChallenges, 'psychometrics'),
  nextGameLink: playNow,
  ...selectGameKeys({ psychometrics }),
});

export default selectScoreCardPsychometrics;
